import React, { useEffect, useRef, useState } from "react";

const C = { ink: "#111615", teal: "#35c4c7", aqua: "#d9f6f2", cream: "#f7f5ef", line: "#d9dfdc" };

const intents = [
  ["rocket", "Explore an AI deployment"],
  ["document", "Invite EpicTravel to an RFP"],
  ["partners", "Discuss a partnership"],
  ["settings", "Request technical information"],
];

const promises = [
  "A discussion focused on your objectives",
  "A recommended deployment approach",
  "Answers on integration, security and governance",
  "Relevant case studies and technical documentation",
];

const ENQUIRY_EMAIL = "enquiry@epictravel.ai";

// INSTALL: Replace src/pages/OTAFront/Contact/index.jsx with this file.
// Zoho webform settings:
//   Form Location URL: https://epictravel.ai/contact
//   Redirect/landing URL: https://epictravel.ai/contact?enquiry=submitted
// Keep /contact available on a direct browser load (SPA hosting fallback).
// The action and public form tokens match the Zoho source uploaded on 9 Sep 2026.
// Compare them with Zoho's latest generated source if leads are still missing.
// This native POST displays Zoho's response instead of hiding it in an iframe.
// The landing URL is a UX signal, NOT proof of a CRM record or email delivery.
// Internal email notification and customer autoresponse must be enabled in Zoho.
const RETURN_URL = "https://epictravel.ai/contact?enquiry=submitted";

const ZOHO = {
  action: "https://crm.zoho.com/crm/WebToLeadForm",

  // From the webform embed code (Setup > Channels > Webforms > Leads).
  // Not secrets: they sit in the public HTML of every site using a Zoho form and
  // only permit creating a lead in this one form.
  orgId: "6011424bcc49d94d16b444955f372a4778f3785d09bd26ac936f1254931547eb", // xnQsjsdp
  formId:
    "d3ae8d03debbfd30294abde929e43b17584f0c6bc209542dfa7169ed87e0c78994c7fef5f5507f3743c5fa8638e4e4d3", // xmIwtLD

  actionType: "TGVhZHM=", // base64 "Leads"
  fields: {
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    organisation: "Company",
    description: "Description",
  },
};

const zohoReady = Boolean(ZOHO.orgId && ZOHO.formId);

function Icon({ name, size = 22 }) {
  const paths = {
    arrow: <><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></>,
    check: <path d="m5 12 4 4L19 6"/>,
    mail: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6 8.5-6"/></>,
    lock: <><rect x="4" y="10.5" width="16" height="10.5" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></>,
    rocket: <><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91 0Z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2Z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></>,
    document: <><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z"/><path d="M14 2v6h6"/><path d="M8.5 13h7"/><path d="M8.5 17h4.5"/></>,
    partners: <><circle cx="9" cy="8" r="3"/><path d="M3 20v-1.5A4.5 4.5 0 0 1 7.5 14h3A4.5 4.5 0 0 1 15 18.5V20"/><path d="M16.5 6.2a3 3 0 0 1 0 5.6"/><path d="M18 14h.5A4.5 4.5 0 0 1 23 18.5V20"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6 1.65 1.65 0 0 0 10 3.09V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name] || paths.check}
    </svg>
  );
}

const initialForm = { firstName: "", lastName: "", email: "", organisation: "", intent: "document", message: "" };

export default function Contact() {
  const [menu, setMenu] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [failed, setFailed] = useState(false);
  const honeypot = useRef(null);
  const submitted = useRef(false);
  const timer = useRef(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get("enquiry") === "submitted") {
      setSent(true);
      url.searchParams.delete("enquiry");
      window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    }
    const onPageShow = () => {
      submitted.current = false;
      clearTimeout(timer.current);
      setSending(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);

  const set = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    setErrors((prev) => (prev[key] ? { ...prev, [key]: undefined } : prev));
  };

  const validate = () => {
    const next = {};
    if (!form.firstName.trim()) next.firstName = "First name is required";
    if (!form.lastName.trim()) next.lastName = "Last name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(form.email.trim())) next.email = "Enter a valid work email";
    if (!form.organisation.trim()) next.organisation = "Organisation is required";
    if (form.message.trim().length < 20) next.message = "Please share at least a few details (20+ characters)";
    if (form.message.length > 3000) next.message = "Please keep your message under 3,000 characters";
    return next;
  };

  const onSubmit = (e) => {
    if (submitted.current) {
      e.preventDefault();
      return;
    }
    const next = validate();
    setErrors(next);
    if (Object.keys(next).length) {
      e.preventDefault();
      const first = document.querySelector(`[data-field="${Object.keys(next)[0]}"]`);
      if (first) first.focus();
      return;
    }
    // Bots fill every field they find; humans never see this one.
    if (honeypot.current && honeypot.current.value) {
      e.preventDefault();
      setFailed(true);
      return;
    }
    if (!zohoReady) {
      // No webform ids configured yet - keep the page usable instead of posting
      // into the void, but make it loud so the success card is not mistaken for
      // a real submission.
      e.preventDefault();
      console.warn(
        "[contact] Enquiry NOT sent: Zoho orgId/formId are empty. " +
          "Fill them in the ZOHO object in src/pages/OTAFront/Contact/index.jsx."
      );
      setFailed(true);
      return;
    }
    // Allow a native, top-level POST. Do not use fetch or a hidden iframe.
    setSending(true);
    setFailed(false);
    submitted.current = true;
    timer.current = setTimeout(() => {
      setSending(false);
      setFailed(true);
      submitted.current = false;
    }, 20000);
  };

  const reset = () => {
    submitted.current = false;
    clearTimeout(timer.current);
    setSending(false);
    setForm(initialForm);
    setErrors({});
    setSent(false);
    setFailed(false);
  };

  return (
    <div className="site">
      <style>{css}</style>

      <header>
        <div className="header-inner">
          <a className="logo" href="/"><img src="/untitled folder 2/image 1.png" alt="EpicTravel.ai" className="logo-img"/></a>
          <nav className={menu ? "open" : ""}>
            <a href="/#platform">Platform</a>
            <a href="/#solutions">Solutions</a>
            <a href="/#technology">Technology</a>
            <a href="/#proof">Proof</a>
            <a href="/#company">Company</a>
            <a href="/#investors">Investor Relations</a>
          </nav>
          <div className="header-actions">
            <div className="login-dropdown">
              <span className="login-link">Log in</span>
              <div className="login-menu">
                <a href="https://visitmalaysia.ai" target="_blank" rel="noopener noreferrer">visitmalaysia.ai</a>
                <a href="https://octotravel.ai" target="_blank" rel="noopener noreferrer">octotravel.ai</a>
              </div>
            </div>
            <button className="btn">RFP / Tender<Icon name="arrow" size={17}/></button>
          </div>
          <button className="menu" onClick={() => setMenu(!menu)} aria-label="Toggle navigation">{menu ? "×" : "☰"}</button>
        </div>
      </header>

      <main>
        <section className="contact">
          <div className="contact-bg" aria-hidden="true"><span className="blob blob-a"/><span className="blob blob-b"/></div>
          <div className="wrap contact-grid">
            <div className="contact-copy">
              <div className="eyebrow">LET'S WORK TOGETHER</div>
              <h1>Turn your transport and travel services into <span className="highlight">AI-powered</span> <span className="highlight">commerce.</span></h1>
              <p>Tell us about your organisation, project or procurement requirements. We'll show you how EpicTravel.ai can connect your services, data and customer channels to AI-powered travel commerce.</p>
              <ul className="promises">
                {promises.map((p) => (
                  <li key={p}><span className="tick"><Icon name="check" size={13}/></span>{p}</li>
                ))}
              </ul>
              <div className="prefer-email">
                <span className="tick tick-outline"><Icon name="mail" size={15}/></span>
                <div>
                  <b>Prefer email?</b>
                  <a href={`mailto:${ENQUIRY_EMAIL}`}>{ENQUIRY_EMAIL}</a>
                </div>
              </div>
            </div>

            <div className="form-card">
              {sent ? (
                <div className="sent">
                  <span className="sent-tick"><Icon name="check" size={26}/></span>
                  <h2>Thank you for your enquiry.</h2>
                  <p>Thank you for submitting your details. For any follow-up, contact <a href={`mailto:${ENQUIRY_EMAIL}`}>{ENQUIRY_EMAIL}</a>.</p>
                  <button type="button" className="btn" onClick={reset}>Send another enquiry<Icon name="arrow" size={17}/></button>
                </div>
              ) : (
                <form
                  id="webform7497344000000738009"
                  name="WebToLeads7497344000000738009"
                  onSubmit={onSubmit}
                  noValidate
                  action={zohoReady ? ZOHO.action : undefined}
                  method={zohoReady ? "POST" : undefined}
                  encType="application/x-www-form-urlencoded"
                  target="_self"
                  acceptCharset="UTF-8"
                >
                  {zohoReady && (
                    <>
                      <input type="hidden" name="xnQsjsdp" value={ZOHO.orgId}/>
                      <input type="hidden" name="xmIwtLD" value={ZOHO.formId}/>
                      <input type="hidden" name="actionType" value={ZOHO.actionType}/>
                      <input type="hidden" name="zc_gad" value=""/>
                      {/* Zoho's own honeypot (base64 "honeypot"); it must arrive empty. */}
                      <input type="hidden" name="aG9uZXlwb3Q" value=""/>
                      <input type="hidden" name="returnURL" value={RETURN_URL}/>
                      {/* Keep the intent in Description using its readable label. */}
                      <input type="hidden" name={ZOHO.fields.description} value={`I want to: ${intents.find(([key]) => key === form.intent)?.[1] || form.intent}\n\n${form.message.trim()}`}/>
                    </>
                  )}

                  <h2>How can we help?</h2>
                  <p className="form-sub">Our team will connect you with the right specialist.</p>

                  <div className="row">
                    <Field label="First name" required error={errors.firstName}>
                      <input data-field="firstName" maxLength={40} name={ZOHO.fields.firstName} type="text" placeholder="John" value={form.firstName} onChange={set("firstName")} autoComplete="given-name"/>
                    </Field>
                    <Field label="Last name" required error={errors.lastName}>
                      <input data-field="lastName" maxLength={80} name={ZOHO.fields.lastName} type="text" placeholder="Appleseed" value={form.lastName} onChange={set("lastName")} autoComplete="family-name"/>
                    </Field>
                  </div>

                  <Field label="Work email" required error={errors.email}>
                    <input data-field="email" maxLength={100} name={ZOHO.fields.email} type="email" placeholder="john@company.com" value={form.email} onChange={set("email")} autoComplete="email"/>
                  </Field>

                  <Field label="Organisation" required error={errors.organisation}>
                    <input data-field="organisation" maxLength={200} name={ZOHO.fields.organisation} type="text" placeholder="Your organisation" value={form.organisation} onChange={set("organisation")} autoComplete="organization"/>
                  </Field>

                  <span className="label">I want to...</span>
                  <div className="intent-grid">
                    {intents.map(([icon, label]) => (
                      <label key={label} className={`intent ${form.intent === label ? "active" : ""}`}>
                        <span className="intent-icon"><Icon name={icon} size={19}/></span>
                        <span className="intent-label">{label}</span>
                        <input type="radio" name="intent" value={label} checked={form.intent === label} onChange={set("intent")}/>
                        <span className="radio" aria-hidden="true"/>
                      </label>
                    ))}
                  </div>

                  <Field label="Tell us about your project" required error={errors.message}>
                    <textarea data-field="message" maxLength={3000} rows={3} placeholder="Share a few details about your requirements, timeline or areas of interest..." value={form.message} onChange={set("message")}/>
                  </Field>

                  <input ref={honeypot} type="text" name="website_url" tabIndex={-1} autoComplete="off" aria-hidden="true" className="honeypot"/>

                  {failed && (
                    <p className="submit-error">
                      We could not confirm your submission. To avoid sending it twice, please contact us at <a href={`mailto:${ENQUIRY_EMAIL}`}>{ENQUIRY_EMAIL}</a>.
                    </p>
                  )}

                  <div className="form-footer">
                    <button type="submit" className="btn btn-send" disabled={sending}>
                      {sending ? "Sending..." : "Send Enquiry"}
                      {!sending && <Icon name="arrow" size={17}/>}
                    </button>
                    <div className="privacy">
                      <span className="privacy-icon"><Icon name="lock" size={15}/></span>
                      <p>We'll only use your information to respond to your enquiry.<br/><a href="/#privacy">View our Privacy Policy.</a></p>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>

      <footer>
        <div className="wrap footer-grid">
          <div className="footer-brand">
            <a className="logo" href="/"><img src="/untitled folder 2/image 1.png" alt="EpicTravel.ai" className="logo-img"/></a>
            <p>Enterprise agentic infrastructure for a world moving from search to AI.</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <b>EXPLORE</b>
              <a href="/#platform">Platform</a>
              <a href="/#solutions">Solutions</a>
              <a href="/#technology">Technology</a>
              <a href="/#proof">Proof</a>
            </div>
            <div className="footer-col">
              <b>ENGAGE</b>
              <a href="/contact">Invite us to your RFP / Tender</a>
              <a href="/#whitepaper">Technical whitepaper</a>
              <a href="/#investors">Investor relations</a>
            </div>
          </div>
        </div>
        <div className="wrap copyright">
          <span>© 2026 EpicTravel AI Sdn. Bhd.</span>
          <span className="copyright-location">Malaysia · Southeast Asia</span>
        </div>
      </footer>
    </div>
  );
}

function Field({ label, required, error, children }) {
  return (
    <div className={`field ${error ? "has-error" : ""}`}>
      <span className="label">{label} {required && <i>*</i>}</span>
      {children}
      {error && <em className="error">{error}</em>}
    </div>
  );
}

const css = `html,body{scrollbar-width:none;-ms-overflow-style:none}html::-webkit-scrollbar,body::-webkit-scrollbar{display:none}
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@500;600&display=swap');

*{box-sizing:border-box}
html{scroll-behavior:smooth}
body{margin:0}
.site{font-family:'DM Sans',sans-serif;color:${C.ink};background:#fff;line-height:1.6}
.wrap{width:100%;max-width:1200px;margin:0 auto;padding:0 20px;box-sizing:border-box}
h1,h2{font-family:'Playfair Display',serif;font-weight:500;line-height:1.05;letter-spacing:-.035em;margin:0}
h1{font-size:clamp(38px,4.4vw,58px)}
h1 .highlight{background:linear-gradient(to top,${C.aqua} 35%,transparent 35%);padding:0 4px}
p{color:#5d6864;margin:0}
a{color:inherit;text-decoration:none}
button{font:inherit}

/* ===== HEADER ===== */
header{height:72px;width:100%;border-bottom:1px solid ${C.line};position:relative;z-index:10;background:#fff}
.header-inner{height:100%;width:100%;max-width:1200px;margin:0 auto;padding:0 20px;display:flex;align-items:center;box-sizing:border-box}
.logo{display:flex;align-items:center;flex-shrink:0}
.logo-img{height:32px;width:auto;display:block}
nav{display:flex;align-items:center;gap:32px;font-size:13px;font-weight:500;margin-left:48px}
nav a{transition:color .2s}
nav a:hover{color:#20aaad}
.header-actions{display:flex;align-items:center;gap:24px;flex-shrink:0;margin-left:auto}
.login-dropdown{position:relative}
.login-link{font-size:13px;font-weight:500;cursor:pointer;display:flex;align-items:center;gap:6px}
.login-link::after{content:'';width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid ${C.ink};transition:transform .2s}
.login-dropdown:hover .login-link::after{transform:rotate(180deg)}
.login-menu{position:absolute;top:calc(100% + 8px);left:50%;transform:translateX(-50%) scale(.95);background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(0,0,0,.12),0 0 0 1px rgba(0,0,0,.05);min-width:200px;padding:8px;opacity:0;visibility:hidden;transition:all .15s ease;z-index:100}
.login-dropdown:hover .login-menu{opacity:1;visibility:visible;transform:translateX(-50%) scale(1)}
.login-menu a{display:flex;align-items:center;gap:12px;padding:10px 12px;font-size:14px;font-weight:500;color:${C.ink};border-radius:8px;transition:background .15s}
.login-menu a:hover{background:#f5f5f5}
.menu{display:none;background:none;border:0;font-size:24px;padding:8px}

/* ===== BUTTONS ===== */
.btn{border:0;border-radius:99px;padding:14px 24px;background:${C.ink};color:#fff;display:inline-flex;align-items:center;justify-content:center;gap:12px;cursor:pointer;font-size:13px;font-weight:600;line-height:1;white-space:nowrap;transition:background .2s}
.btn:hover{background:#178b8d}

/* ===== CONTACT SECTION ===== */
.contact{position:relative;overflow:hidden;background:linear-gradient(135deg,#f2fbf9 0%,#f7fdfc 42%,#ffffff 100%);padding:72px 0 88px}
.contact-bg{position:absolute;inset:0;pointer-events:none}
.blob{position:absolute;border-radius:50%;display:block}
.blob-a{width:520px;height:520px;top:-180px;right:-140px;background:radial-gradient(circle at 30% 30%,rgba(53,196,199,.16),rgba(53,196,199,0) 68%)}
.blob-b{width:420px;height:420px;bottom:-160px;left:-130px;background:radial-gradient(circle at 60% 40%,rgba(53,196,199,.13),rgba(53,196,199,0) 70%)}
.contact-grid{position:relative;display:grid;grid-template-columns:1fr 1.05fr;gap:72px;align-items:start}

.contact-copy{padding-top:16px;max-width:520px}
.eyebrow{font-size:11px;font-weight:700;letter-spacing:.18em;color:#178b8d;margin-bottom:22px}
.contact-copy>p{font-size:16.5px;line-height:1.7;margin:26px 0 32px;max-width:470px}
.promises{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:16px}
.promises li{display:flex;align-items:flex-start;gap:14px;font-size:14.5px;color:#3f4a48;line-height:1.5}
.tick{flex-shrink:0;width:22px;height:22px;border-radius:50%;background:${C.teal};color:#fff;display:inline-flex;align-items:center;justify-content:center;margin-top:1px;box-shadow:0 2px 6px rgba(53,196,199,.35)}
.tick-outline{background:#fff;color:#178b8d;border:1.5px solid ${C.teal};width:30px;height:30px;box-shadow:none}
.prefer-email{display:flex;align-items:center;gap:14px;margin-top:34px}
.prefer-email b{display:block;font-size:13.5px;font-weight:600;color:#3f4a48;line-height:1.35}
.prefer-email a{font-size:14px;font-weight:500;color:#178b8d;text-decoration:underline;text-underline-offset:3px}
.prefer-email a:hover{color:#0f6f71}

/* ===== FORM CARD ===== */
.form-card{background:#fff;border:1px solid #eef2f1;border-radius:18px;padding:36px 34px 32px;box-shadow:0 18px 50px rgba(17,22,21,.07),0 2px 6px rgba(17,22,21,.03)}
.form-card h2{font-size:31px}
.form-sub{font-size:14.5px;margin:10px 0 26px}
.row{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.field{display:flex;flex-direction:column;margin-bottom:16px}
.label{display:block;font-size:12.5px;font-weight:500;color:#3f4a48;margin-bottom:7px}
.label i{color:#e0284a;font-style:normal}
input[type=text],input[type=email],textarea{width:100%;border:1px solid #e3e8e7;border-radius:8px;padding:11px 13px;font-family:inherit;font-size:14px;color:${C.ink};background:#fff;transition:border-color .18s,box-shadow .18s;outline:none}
input::placeholder,textarea::placeholder{color:#a9b3b1}
input[type=text]:focus,input[type=email]:focus,textarea:focus{border-color:${C.teal};box-shadow:0 0 0 3px rgba(53,196,199,.15)}
textarea{resize:vertical;min-height:86px;line-height:1.55}
.field.has-error input,.field.has-error textarea{border-color:#e0284a}
.error{font-style:normal;font-size:11.5px;color:#e0284a;margin-top:6px}

/* ===== INTENT SELECTOR ===== */
.intent-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:0 0 20px}
.intent{position:relative;display:flex;align-items:center;gap:11px;padding:13px 40px 13px 13px;border:1px solid #e3e8e7;border-radius:10px;cursor:pointer;background:#fff;transition:border-color .18s,box-shadow .18s,background .18s;min-height:56px}
.intent:hover{border-color:#bfe6e5}
.intent input{position:absolute;opacity:0;width:0;height:0}
.intent-icon{flex-shrink:0;color:#5d6864;display:inline-flex}
.intent-label{font-size:12.5px;font-weight:500;line-height:1.35;color:#3f4a48}
.radio{position:absolute;right:13px;top:50%;transform:translateY(-50%);width:15px;height:15px;border-radius:50%;border:1.5px solid #d3dbd9;background:#fff;transition:border-color .18s,background .18s}
.intent.active{border-color:${C.teal};background:#f4fdfc;box-shadow:0 0 0 3px rgba(53,196,199,.12)}
.intent.active .intent-icon{color:#178b8d}
.intent.active .intent-label{color:${C.ink}}
.intent.active .radio{border-color:${C.teal};background:${C.teal};box-shadow:inset 0 0 0 2.5px #fff}
.intent input:focus-visible + .radio{box-shadow:0 0 0 3px rgba(53,196,199,.3)}

/* Off-screen rather than display:none so bots still fill it in. */
.honeypot{position:absolute!important;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none}
.zoho-frame{display:none}
.submit-error{font-size:12.5px;line-height:1.55;color:#c21f3f;background:#fdf2f4;border:1px solid #f7d4dc;border-radius:8px;padding:11px 13px;margin-bottom:18px}
.submit-error a{color:#c21f3f;font-weight:600;text-decoration:underline}

/* ===== FORM FOOTER ===== */
.form-footer{display:flex;align-items:center;justify-content:space-between;gap:24px}
.btn-send{background:#1497a4;padding:15px 26px;font-size:13.5px}
.btn-send:hover{background:#0f7a85}
.btn-send:disabled{background:#9dc7cc;cursor:not-allowed}
.privacy{display:flex;align-items:flex-start;gap:9px;max-width:290px}
.privacy-icon{color:#178b8d;flex-shrink:0;margin-top:1px}
.privacy p{font-size:10.5px;line-height:1.55;color:#8a9694}
.privacy a{color:#178b8d;text-decoration:underline;text-underline-offset:2px}

/* ===== SENT STATE ===== */
.sent{text-align:center;padding:40px 10px 30px;display:flex;flex-direction:column;align-items:center}
.sent-tick{width:56px;height:56px;border-radius:50%;background:${C.aqua};color:#0f7a85;display:inline-flex;align-items:center;justify-content:center;margin-bottom:22px}
.sent h2{font-size:28px}
.sent p{font-size:15px;line-height:1.7;margin:14px 0 28px;max-width:380px}
.sent strong{color:${C.ink}}

/* ===== FOOTER ===== */
footer{background:#fff;color:${C.ink};padding:80px 0 30px;border-top:1px solid ${C.line}}
.footer-grid{display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:start}
.footer-brand{max-width:360px}
.footer-brand .logo-img{height:28px;width:auto}
.footer-brand p{margin-top:20px;font-size:14px;line-height:1.7;color:#5d6864}
.footer-links{display:flex;gap:80px}
.footer-col{display:flex;flex-direction:column;gap:14px}
.footer-col b{font-size:11px;font-weight:600;letter-spacing:.1em;color:#5d6864;margin-bottom:8px}
.footer-col a{font-size:14px;color:${C.ink};transition:color .2s}
.footer-col a:hover{color:#178b8d}
.copyright{display:flex;justify-content:space-between;align-items:center;margin-top:60px;padding-top:24px;border-top:1px solid ${C.line};font-size:12.5px;color:#8a9694}

/* ===== RESPONSIVE ===== */
@media (max-width:1080px){
.contact-grid{gap:48px}
}
@media (max-width:900px){
nav{display:none;margin-left:0}
nav.open{display:flex;position:absolute;top:72px;left:0;right:0;flex-direction:column;align-items:flex-start;gap:0;background:#fff;border-bottom:1px solid ${C.line};padding:8px 20px 16px;box-shadow:0 12px 24px rgba(0,0,0,.06);z-index:20}
nav.open a{padding:12px 0;width:100%;border-bottom:1px solid #f0f3f2}
.menu{display:block;margin-left:auto}
.header-actions{display:none}
.contact{padding:48px 0 64px}
.contact-grid{grid-template-columns:1fr;gap:44px}
.contact-copy{max-width:100%;padding-top:0}
.footer-grid{grid-template-columns:1fr;gap:44px}
.footer-links{gap:56px}
}
@media (max-width:600px){
.form-card{padding:26px 20px 24px}
.form-card h2{font-size:26px}
.row,.intent-grid{grid-template-columns:1fr}
.form-footer{flex-direction:column;align-items:stretch;gap:18px}
.btn-send{width:100%}
.privacy{max-width:100%}
.copyright{flex-direction:column;align-items:flex-start;gap:8px}
}
`;
